<template>
<div style="margin-left: auto; margin-right: auto;  width: 100%; position: relative" id="commonRight">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 642 642" style="enable-background:new 0 0 642 642;" xml:space="preserve">
<g>
	<g>
		<path class="body" d="M393.81,122.83c2.11,2.94,4.42,5.71,7.14,8.1c2.98,2.61,4.04,6.25,5.1,9.77c4.04,13.33,8.27,26.61,11.7,40.1
			c2.83,11.14,4.78,22.5,7.09,33.77c4.84,23.63,4.73,47.71,7.47,71.52c1.21,10.53,3.01,20.98,4.26,31.51
			c1.5,12.61,2.83,25.24,3.99,37.88c1.17,12.64,1.97,25.31,3.96,37.86c0.86,5.43,0.27,10.93,0.14,16.41
			c-0.28,12.47-0.47,24.95-0.52,37.42c-0.06,16.33-4.02,32.04-7.4,47.85c-2.15,10.05-6.29,19.43-9.72,29.05
			c-1.21,3.39-3.57,5.97-6.65,7.86c-5.62,0.75-11.08,2.54-16.79,2.75c-10.37,0.37-20.76,0.19-31.06-0.79
			c-4.41-0.42-9.18,0.55-13.28-2.09c0.59-3.09,2.56-5.66,3.01-8.89c1.61-11.53,0.51-23.05,0.24-34.58
			c-0.26-11.07-1.19-22.16,0.43-33.19c0.5-3.39,0.48-6.68,0.24-10.08c-0.81-11.45,0.17-22.84,1.62-34.19
			c0.71-5.58,3.93-10.51,4.25-16.18c0.82-14.44,1.5-28.88,2.46-43.31c0.63-9.55,0.06-19.15,1.26-28.66
			c1.01-8.03,1.38-16.14,0.3-24.1c-0.74-5.44,0.13-10.14,2.45-14.82c2.17-4.38,2.9-8.92,2.89-13.84
			c-0.02-10.61,0.27-21.25,0.94-31.84c0.65-10.3-0.15-20.52-0.78-30.76c-0.48-7.88-3.65-15.14-5.31-22.75
			c-2.03-9.34-4.3-18.63-7.62-27.59c-5.54-14.97-11.85-29.4-25.47-39.29c-5.9-4.29-12.04-7.42-19.19-8.67
			c-20.44-3.59-30.93,1.26-41.14,19.35c-7.02,12.44-12.04,25.7-16.21,39.35c-5.88,19.24-7.18,38.94-6.29,58.83
			c0.31,6.9,0.7,13.72-0.18,20.58c-0.56,4.39-0.83,8.82-1.49,13.2c-1.82,12.13-0.65,24.49-2.9,36.57
			c-0.79,4.25-0.01,8.57-0.66,12.87c-2.31,15.51-2.24,31.12-1.64,46.75c0.05,1.4,0.22,2.82,0.05,4.19
			c-1.72,14.07-1.63,28.23-1.06,42.31c0.52,12.69,1.99,25.35,1.06,38.08c-1.32,18.04-2.44,36.09-1.7,54.19
			c0.28,6.77,0.3,13.68,4.03,19.63c2.5,4,3.23,8.15,2.93,12.67c-2.63,0.16-5.23-0.06-7.86-0.31c-3.13-0.29-6.67-1.6-9.36,1.48
			c-13.17-1.1-19.54-10.32-25.06-20.74c-7.41-13.99-10.03-29.01-11.19-44.66c-1.88-25.44,1.09-50.52,4.21-75.62
			c2.29-18.44,3.14-36.92,3.03-55.49c-0.12-19.16,1.96-38.16,5.81-56.94c2.16-10.57,2.26-21.3,2.95-31.98
			c0.86-13.3,3.89-26.24,6.16-39.31c5.54-31.81,18.44-60.85,33.87-88.87c5.4-9.8,10.62-19.65,14.94-29.97
			c0.48-1.15,0.85-2.44,2.05-3.15c6.33-1.43,12.75-2.4,19.23-2.67c15.18-0.64,29.67,3.28,44.02,7.48
			c10.47,3.06,20.76,6.79,29.75,13.38c7.44,5.46,14.2,11.64,20.66,18.19c0.93,0.94,1.61,2.4,3.33,2.2c0,0-0.02-0.01-0.02-0.01
			c-0.06,0.46,0.17,0.71,0.61,0.79c0,0,0,0.01,0,0.01C392.84,122.14,393.12,122.62,393.81,122.83z M426.93,349.34
			c0.43-2.17-0.54-3.82-2.13-5.18c-1.04-0.88-1.9-2.66-3.33-2.16c-1.49,0.52-1.02,2.4-1.03,3.74c-0.02,3.26,0.06,6.53,0.1,9.8
			c0.04,2.69,0.04,5.38-0.86,7.95c-2.22,6.3-2.82,12.89-3.82,19.44c-3.04,19.88-7.82,39.44-11.88,59.12
			c-1.7,8.23-3.62,16.6-8.32,23.92c-1.31,2.05-4.6,4.02-3.5,6.14c0.91,1.75,4.43,2.09,6.74,3.16c1.58,0.73,2.63,0.36,3.47-1.13
			c4.57-8.11,9.2-16.24,11.63-25.29c2.78-10.35,3.52-21.09,5.52-31.58C423.8,394.79,426.8,372.24,426.93,349.34z"/>
		<path class="solid" d="M238.6,528.8c2.69-3.08,6.23-1.77,9.36-1.48c2.63,0.24,5.23,0.47,7.86,0.31c1.05,1.86,0.52,3.89,0.53,5.83
			c0.01,3.19,0.54,6.28,1.58,9.26c2.54,7.28,8.87,10.16,16.22,7.53c1.53-0.55,3.1-1.35,4.66-1.36c11.18-0.07,22.41-0.64,33.52,0.28
			c9.36,0.78,18.75,1.8,28.1,2.96c2.06,0.25,3.71,0.32,3.49,3.48c3.84-3.48,6.5-6.87,8.59-10.87c2.25-4.31,3.84-8.97,6.77-12.92
			c4.1,2.64,8.88,1.67,13.28,2.09c10.3,0.98,20.69,1.16,31.06,0.79c5.7-0.2,11.16-1.99,16.79-2.75c-0.03,13.66-0.18,27.32,0,40.97
			c0.05,3.96-1.56,6.01-5.04,7.29c-3.79,1.4-7.74,1.79-11.67,2.05c-12.81,0.83-25.63,1.03-38.47,0.28
			c-8.03-0.47-16.1,0.29-24.12-0.57c-1.2-0.13-1.94,0.13-2.07,1.6c-0.55,5.93-1.16,11.85-0.46,17.81c0.49,4.17-0.32,5.31-4.63,5.33
			c-5.01,0.02-10.02-0.37-15.03-0.48c-13.19-0.28-26.37,0.19-39.54,0.72c-0.47,0.02-0.98-0.05-1.39,0.11
			c-3.32,1.33-4.35-0.35-4.18-3.28c0.38-6.9-0.46-13.76-0.59-20.64c-0.1-5.54-0.17-5.76-5.74-6.12c-7.69-0.5-15.29-1.56-22.84-3.03
			c-5.41-1.05-5.95-1.98-5.86-7.35C238.96,554.01,239.17,541.41,238.6,528.8z"/>
		<path class="solid" d="M392.35,120.64c-1.72,0.2-2.41-1.26-3.33-2.2c-6.46-6.55-13.22-12.73-20.66-18.19
			c-8.98-6.59-19.27-10.32-29.75-13.38c-14.35-4.2-28.83-8.12-44.02-7.48c-6.48,0.27-12.9,1.24-19.23,2.67
			c1.6-9.31,4.48-18.3,6.58-27.49c0.71-3.09,2.8-4.17,5.37-4.69c6.76-1.38,13.48-0.29,20.14,0.81c18.79,3.1,36.16,9.76,51.36,21.41
			c7.49,5.74,13.11,13.33,17.96,21.3c5.14,8.45,9.81,17.2,14.98,25.65C392.04,119.54,392.15,120.11,392.35,120.64z"/>
		<path class="solid" d="M393.81,122.83c-0.7-0.21-0.97-0.69-0.88-1.4C393.58,121.67,393.72,122.24,393.81,122.83z"/>
		<path class="solid" d="M392.93,121.42c-0.44-0.08-0.66-0.33-0.61-0.79C392.86,120.65,392.96,120.99,392.93,121.42z"/>
		<path class="sleeve" d="M359.26,531.8c-2.92,3.95-4.52,8.62-6.77,12.92c-2.09,4-4.75,7.39-8.59,10.87c0.22-3.15-1.43-3.22-3.49-3.48
			c-9.35-1.16-18.74-2.18-28.1-2.96c-11.11-0.92-22.34-0.35-33.52-0.28c-1.56,0.01-3.13,0.81-4.66,1.36
			c-7.34,2.64-13.67-0.25-16.22-7.53c-1.04-2.98-1.57-6.06-1.58-9.26c-0.01-1.94,0.52-3.97-0.53-5.83c0.3-4.52-0.43-8.68-2.93-12.67
			c-3.73-5.96-3.75-12.87-4.03-19.63c-0.74-18.1,0.37-36.15,1.7-54.19c0.93-12.73-0.54-25.38-1.06-38.08
			c-0.58-14.08-0.66-28.24,1.06-42.31c0.17-1.37,0-2.79-0.05-4.19c-0.6-15.62-0.67-31.24,1.64-46.75c0.64-4.3-0.14-8.62,0.66-12.87
			c2.26-12.09,1.08-24.45,2.9-36.57c0.66-4.38,0.93-8.81,1.49-13.2c0.88-6.86,0.49-13.69,0.18-20.58
			c-0.89-19.89,0.41-39.59,6.29-58.83c4.17-13.65,9.19-26.91,16.21-39.35c10.21-18.1,20.7-22.95,41.14-19.35
			c7.16,1.26,13.29,4.39,19.19,8.67c13.62,9.89,19.92,24.33,25.47,39.29c3.32,8.96,5.59,18.25,7.62,27.59
			c1.66,7.61,4.83,14.87,5.31,22.75c0.62,10.24,1.43,20.46,0.78,30.76c-0.67,10.59-0.96,21.23-0.94,31.84
			c0.01,4.93-0.73,9.47-2.89,13.84c-2.31,4.68-3.19,9.38-2.45,14.82c1.09,7.95,0.72,16.07-0.3,24.1c-1.2,9.52-0.62,19.11-1.26,28.66
			c-0.96,14.43-1.64,28.88-2.46,43.31c-0.32,5.67-3.54,10.61-4.25,16.18c-1.45,11.35-2.43,22.74-1.62,34.19
			c0.24,3.4,0.26,6.69-0.24,10.08c-1.62,11.03-0.69,22.12-0.43,33.19c0.27,11.53,1.38,23.04-0.24,34.58
			C361.82,526.13,359.85,528.7,359.26,531.8z"/>
		<path class="pocket" d="M426.93,349.34c-0.13,22.9-3.13,45.46-7.41,67.93c-2,10.48-2.75,21.23-5.52,31.58
			c-2.43,9.05-7.05,17.18-11.63,25.29c-0.84,1.49-1.89,1.86-3.47,1.13c-2.32-1.07-5.84-1.42-6.74-3.16c-1.1-2.12,2.18-4.08,3.5-6.14
			c4.69-7.33,6.62-15.69,8.32-23.92c4.06-19.69,8.84-39.24,11.88-59.12c1-6.56,1.6-13.14,3.82-19.44c0.9-2.57,0.9-5.26,0.86-7.95
			c-0.04-3.27-0.12-6.53-0.1-9.8c0.01-1.34-0.46-3.22,1.03-3.74c1.43-0.5,2.29,1.28,3.33,2.16
			C426.39,345.51,427.36,347.16,426.93,349.34z"/>
	</g>
	<g>
		<path class="single_stripe" d="M420.21,543.91c-0.01,6.02-0.02,12.03-0.03,18.05c-6.31,5.12-13.89,6.75-21.65,7.79
			c-15.85,2.13-31.78,1.74-47.69,1.41c-10.93-0.22-10.93-0.39-11.73,10.52c-0.01,0.11,0.03,0.23,0.05,0.35c-0.26,2,0,4.06-0.75,5.99
			c-1.43,0.66-2.96,0.51-4.47,0.52c-20.15,0.07-40.31,0.14-60.46,0.2c-0.34-3.75-0.67-7.5-1.01-11.25c0.29-2.24-0.18-4.42-0.55-6.6
			c-0.29-1.72,0.23-2.4,2.13-2.62c3.61-0.43,7.21-0.55,10.82-0.52c18.2,0.19,36.41-0.67,54.6,0.45c1.55,0.09,1.59-0.78,1.79-1.9
			c0.68-3.78,1.48-7.54,2.23-11.3c2.65-0.68,3.69-3.3,5.73-4.72c12.67,0.91,25.37,0.62,38.06,0.75
			C398.77,551.15,410.09,550.28,420.21,543.91z"/>
		<path class="single_stripe" d="M383.49,112.91c-3.79-3.46-7.59-6.92-11.39-10.38c-0.8-0.96-1.19-2.42-2.86-2.3c0,0,0.11,0,0.11,0
			c-1.26-3.15-4.06-4.9-6.53-6.85c-15.42-12.21-33.04-19.47-52.39-22.31C299.15,69.41,287.7,68,277,73.99
			c1.21-4.7,2-9.52,3.86-14.04c4.25-2.2,8.83-2.86,13.53-2.96c9.18-0.19,17.97,1.99,26.84,4.09c19.37,4.59,35.56,14.23,48.59,29.24
			C375.68,97.06,380.39,104.49,383.49,112.91z"/>
		<path class="single_stripe" d="M269.84,550.98c0.42,3.69,0.82,7.39,1.25,11.08c0.16,1.36-0.06,2.22-1.76,2.14
			c-8.73-0.42-17.45-0.85-25.78-3.85c-1.61-0.58-3.04-1.68-4.55-2.53c0-6.2,0-12.4-0.01-18.6c6.05,2.59,12.37,3.9,18.95,3.96
			C260.16,548.45,263.92,551.35,269.84,550.98z"/>
	</g>
	<path class="double_stripe" d="M420.16,558.49c0.01,2.87,0.03,5.74,0.04,8.61c-4.57,3.92-10.01,5.84-15.82,6.87
		c-19.71,3.49-39.53,1.53-59.32,1.23c-3.28-0.05-5.3-2.53-8.44-2.53c-20.31,0-40.62-0.15-60.93-0.27c-1.13-0.01-3.02,0.5-3.23-0.54
		c-0.61-3.07-2.95-2.16-4.66-2.37c-4.16-0.51-8.38-0.58-12.52-1.16c-5.86-0.83-11.86-1.48-16.28-6.18c0.01-2.85,0.02-5.7,0.03-8.55
		c3.18,1.71,6.44,3.17,10.07,3.66c9.63,1.3,19.26,2.38,29.03,2.27c12.69-0.15,25.38,0.18,38.08,0.3c7.33,0.07,14.68-0.21,21.98,0.82
		c1.8,0.25,4.15-0.64,3.84,2.77c-0.11,1.24,1.45,0.77,2.27,0.84c15.92,1.22,31.87,1.86,47.82,1.25
		C401.86,565.13,411.63,564.1,420.16,558.49z"/>
	<path class="double_stripe" d="M273.35,584.1c21.86,0.36,43.72,0.65,65.58,0.18c-0.26,3.96-0.51,7.91-0.77,11.87
		c-3.21,0.59-6.44,0.98-9.72,0.97c-14.57-0.04-29.14,0.02-43.71-0.04c-3.6-0.02-7.23,0.31-10.78-0.64
		C273.58,592.34,273.14,588.24,273.35,584.1z"/>
	<path class="double_stripe" d="M385.22,114.42c-1.62-1.12-2.87-2.58-3.98-4.18c-7.97-15.06-19.05-27.18-33.77-35.89
		c-12.64-7.49-26.54-11.15-40.9-13.13c-8.98-1.24-18.09-2.07-26.78,1.88c0.71-2.7,1.42-5.4,2.13-8.09
		c7.05-2.79,14.32-2.51,21.67-1.62c18.15,2.22,35.19,7.18,50.22,18.26C368.81,82.71,378.08,97.73,385.22,114.42z"/>
	<path class="double_stripe" d="M352.99,543.83c14.13,1.01,28.25,2.45,42.44,2.1c8.6-0.21,17.19-0.8,24.77-5.64
		c-0.01,3.09-0.02,6.18-0.03,9.28c-8.46,5.16-17.89,6.13-27.49,6.35c-15.14,0.35-30.22-0.97-45.33-1.72
		c-0.45-0.02-0.9-0.22-1.34-0.34C348.65,550.75,351.09,547.48,352.99,543.83z"/>
	<path class="double_stripe" d="M277.6,71.86c8.4-4.69,17.61-4.45,26.6-3.49c18.39,1.96,35.67,7.59,51.25,17.87
		c6.86,4.53,12.83,10.05,18.14,16.31c0.59,0.69,1.33,1.35,1.21,2.42c-7.39-5.94-15.41-10.82-24.21-14.39
		c-11.95-7.61-25.23-11.72-39.04-13.91c-12.09-1.92-24.29-2.81-35.64,3.57C276,77.34,276.87,74.62,277.6,71.86z"/>
	<path class="double_stripe" d="M261.35,548.71c-7.68-0.12-15.27-0.77-22.33-4.2c-0.01-3.27-0.01-6.54-0.02-9.81
		c4.89,1.97,10.05,2.69,15.22,3.34c0.91,0.12,2.19,0.71,2.45-0.98C257.31,541.32,258.64,545.29,261.35,548.71z"/>
	
		<image style="overflow:visible;" class="ms-filter" width="325" height="584" xlink:href="https://www.customvarsityapparel.com.au/customize/img/jacket_design/jacket_right.png" transform="matrix(1.0274 0 0 1.0274 154.0479 21)">
	</image>
</g>
</svg>

<!-- rightSleeve  Letters Starts  -->
<div v-show="rightSleeve_id === 'rightSleeve_letters'" class="rightSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="rightSleeve_container rightSleeve_letters_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="rightSleeve_letters">
			{{rightSleeve_letters}}
		</text>
	</svg>
</div>
<!-- rightSleeve  letetrs Ends  -->
<!-- rightSleeve Years Starts -->
<div v-show="rightSleeve_id === 'rightSleeve_years'" class="rightSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<svg class="rightSleeve_container rightSleeve_years_holder">
		<text dominant-baseline="central" text-anchor="middle" y="50%" x="50%" class="rightSleeve_years">
			{{rightSleeve_years}}
		</text>
	</svg>
</div>
<!-- rightSleeve Years Ends -->
<!-- rightSleeve Logos Starts -->
<div v-show="rightSleeve_id === 'rightSleeve_logos'" class="rightSleeve_box" style="display: block; fill: rgb(255, 255, 255);">
	<img :src="rightSleeve_logos" alt="" class="rightSleeve_logos">
</div>
<!-- rightSleeve Logos Ends -->


	</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	name: 'JacketRight',
	created() {
		this.$store.watch( getters => getters.rightSleeve_id)
		this.$store.watch( getters => getters.rightSleeve_letters)
		this.$store.watch( getters => getters.rightSleeve_years)
		this.$store.watch( getters => getters.rightSleeve_logos)

	},
	computed: {
		...mapGetters({
			rightSleeve_id: 'rightSleeve_id',
			rightSleeve_letters: 'rightSleeve_letters',
			rightSleeve_years: 'rightSleeve_years',
			rightSleeve_logos: 'rightSleeve_logos',
			
		}),
	}
}
</script>
<style scoped>
.body{fill:white;}
.solid{fill: white;}
.sleeve{fill:white;}
.pocket{fill:white;}
.single_stripe{fill:white;}
.double_stripe{fill:white;}
.ms-filter{mix-blend-mode: multiply;}


.rightSleeve_box {
    padding-bottom: 10%;
    top: 25%;
    width: 10%;
	right: 45.5%;
	position: absolute;
    z-index: 1;
}
.rightSleeve_container {
    left: 50%;
    overflow: visible;
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
	-webkit-text-stroke: 5px transparent;
}

.rightSleeve_letters_holder{
  	font-size: 2em;
	font-family: 'Athletic', sans-serif;
}

.rightSleeve_years_holder{
  	font-size: 3em;
	font-family: 'Athletic', sans-serif;
}

.rightSleeve_letters{
  display: none;
  fill: #000;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: transparent;		
}

.rightSleeve_years{
  display: none;
  fill: #fff;
  stroke-width: 8px;
  paint-order: stroke;
  stroke: #e22c09;		
}

.rightSleeve_logos{
  display: none;
  width: 100%;
}

</style>